import './styles.scss'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import useSpeechToText from 'react-hook-speech-to-text'

import { CHANNELINCHAT } from 'constants/channels'
import { getStaticImage } from 'utils/statics'
import { composerAct } from 'redux/actions'
import supportBrowser from 'hocs/supportBrowser'

const localeSpeech = {
  ca: 'ca',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  en: 'en-GB',
}

/**
 * @param {string} composerMessage;
 */
const ButtonSpeechTranscription = ({ composerMessage, channel, addExternalText }) => {
  const [isRecording, setIsRecording] = useState(false)
  const [speechText, setSpeechText] = useState({ latest: undefined, current: undefined })
  const language = useSelector((store) => store.user.locale)
  const dispatch = useDispatch()

  const {
    error,
    results,
    startSpeechToText,
    stopSpeechToText,
    interimResult
  } = useSpeechToText({
    continuous: true,
    timeout: 10000,
    speechRecognitionProperties: {
      lang: localeSpeech[language],
      interimResults: true
    }
  })

  // On transcription change, update with callback
  useEffect(() => {
    if (interimResult && isRecording) {
      setSpeechText(state => ({ ...state, current: `${state.latest ? state.latest : ''}${interimResult}` }))
    } else {
      stopRecording()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interimResult,composerMessage])

  useEffect(() => {
    if (isRecording) {
      setSpeechText(state => ({ ...state, latest: `${state.latest ? state.latest : ''} ${results[results.length - 1] ? results[results.length - 1] : ''}` }))
    } else {
      stopRecording()
    }
  }, [results])

  useEffect(() => {
    if(speechText.current) {
      if (CHANNELINCHAT.includes(channel))
        addExternalText && addExternalText(speechText.current)
      else
        dispatch(composerAct.addExternalText(speechText.current))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [speechText.current])

  useEffect(() => {
    if (!composerMessage.length) {
      setSpeechText({ latest: undefined, current: undefined })
    }
    if(isRecording && !composerMessage.length) {
      stopRecording()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [composerMessage])

  const startRecording = () => {
    stopSpeechToText()
    if (composerMessage) {
      setSpeechText({ latest: `${composerMessage}`, current: undefined })
    }
    setIsRecording(true)
    startSpeechToText()
  }

  const stopRecording = () => {
    setSpeechText({ latest: undefined, current: undefined })
    stopSpeechToText()
    setIsRecording(false)
  }

  if (error) return null

  return (
    <button
      title={I18n.t('dashboard_transcribe')}
      className='button-speech-transcription'
      onClick={()=> isRecording ? stopRecording() : startRecording()}
    >
      <figure>
        {isRecording ? (
          <>
            <img src={getStaticImage('/icons/orange-brand/icon-mic-transcription-red.svg')} alt='Audio transcription' />
            <div className='button-speech-transcription__pulse'></div>
          </>
        ) : (
          <img src={getStaticImage('/icons/orange-brand/icon-mic-transcription-grey.svg')} alt='Audio transcription' />
        )}
      </figure>
    </button>
  )
}

export default supportBrowser(
  ButtonSpeechTranscription,
  ['chrome']
)
